"use client";
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';


const Thankyoucart = () => {
    const navigate = useNavigate();
     useEffect(() => {
    window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
  }, []);
 
  const handleHomeClick = () => {
    navigate('/');
  };
  return (
    <div>
     <div className="w-full">
        <Header />
      </div>
    <main className="flex gap-7 p-10 w-full min-h-screen bg-neutral-50 max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4">
      {/* <div className="flex-shrink-0 w-[285px] max-xl:w-full">
        <FilterSidebar />
      </div> */}

      <section className="flex flex-col flex-1 gap-0 min-w-0">
        
        <header className="flex justify-between items-center max-sm:flex-col max-sm:items-start max-sm:gap-2">
          
         
        </header>
        <main className="flex-1 flex flex-col items-center justify-center text-center px-4">
        {/* Use your uploaded empty cart image */}
       <div className="bg-[#2BB927] rounded-full p-4 mb-6">
        <svg
          className="w-12 h-12 text-white"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <h1 className="text-2xl font-semibold text-gray-800 mb-2">
        Thank you, your order <br />has been placed
      </h1>
        {/* Delivery Info */}
      <p className="text-gray-600 mb-1">Deliver to</p>
      <p className="font-medium text-gray-900">Julian Smith</p>
      <p className="text-gray-600">1901 Thornridge Cir. Shiloh, Hawaii 81063</p>
      <p className="text-gray-600 mb-6">+1 984 654 6543</p>
       <div className="flex gap-4">
        <button
          onClick={() => alert("Track order functionality here")}
          className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-lg shadow-md transition"
        >
          Track order
        </button>
        <button
          onClick={() => navigate("/")}
          className="text-green-600 hover:underline"
        >
          Go to Home
        </button>
      </div>


      </main>

       

       
      </section>
    </main>
    <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};

export default Thankyoucart;
